import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.css']
})
export class ProcessComponent implements OnInit {

  isTypePage    = 'login';
  pointUUID     = '';
  pointStatus   = 'on';
  detailText    = '';
  loading = true;

  constructor(public cm:CommonService,private _route: ActivatedRoute) { }

  ngOnInit() {

    this._route.params.subscribe((params) => {
      const point_uuid = params['id'];
      var body = {
        point_uuid:point_uuid
      }
      this.cm.postHtpp('getdata',body).then((res:any)=>{

        this.pointUUID  = res.point_uuid;
        this.detailText = res.name;
        this.pointStatus = res.status;
        this.loading = false;
      });

    });

   
  }

  callInput;
  showOTPInput = false;
  
  getOTP(){
    if(this.cm.checkinput(this.callInput,'==',10) && this.callInput.match(/^\d{10}$/)){
      this.loading = true;
      // test site
      var body = {
        call:this.callInput
      }
      this.cm.postHtpp('getotp',body).then((res:any)=>{
        this.ref_code = res.refcode;
        this.token = res.token;
        this.loading = false;
        this.showOTPInput = true;
        this.cm.toastr.success('ส่ง SMS รหัสผ่านเรียบร้อยแล้ว','สำเร็จ');
      }).catch((err)=>{
        this.loading = false;
        this.callInput = '';
        this.cm.toastr.warning('ไม่มีเบอร์มือถือนี้อยู่ในระบบ','แจ้งเตือน');
      })
    } else {
      this.cm.toastr.warning('คุณกรอกข้อมูลไม่ถูกต้อง','แจ้งเตือน');
    }
  }

  OTPInput;
  ref_code = '';
  token = '';
  checkOTP(){
    if(this.cm.checkinput(this.ref_code,'==',6) || this.cm.checkinput(this.OTPInput,'==',6) || this.token){
      this.loading = true;
      var body = {
        token:this.token,
        otp:this.OTPInput,
        ref:this.ref_code,
        point_uuid:this.pointUUID,
        call:this.callInput
      }
      this.cm.postHtpp('checkotp',body).then((res)=>{
        this.loading = false;
        this.cm.toastr.success('เริ่มต้นการชาจน์','สำเร็จ');
        this.isTypePage = 'start'; 
      }).catch((err)=>{
        this.loading = false;
        this.OTPInput = '';
        this.cm.toastr.warning('รหัส OTP ไม่ถูกต้อง','แจ้งเตือน');
      });
    } else {
      this.cm.toastr.warning('คุณกรอกข้อมูลไม่ถูกต้อง','แจ้งเตือน');
    }
    
  }

}
